import { Grid, ListItem, ListItemButton, ListItemText, TextField, Typography } from "@mui/material";
import { getPericiaCustomPrice } from "../../../../entities/pericia/model/pericia";
import { currencyMask, formatIntegerToCurrency } from "../../../../shared/lib/numbers";
import { PaperCard } from "../../../../shared/ui/paper-card/paper-card.component";
import { PericiaInvoiceItem } from "../../../../entities/pericia";
import { LoadingButton } from "@mui/lab";

interface PericiasListByDateComponentProps {
  props: {
    pericias: PericiaInvoiceItem[];
    selectedFieldsToDisplay: SelectedFieldsToDisplay;
    totalPrice: number;
    totalCostumers: number;
    fetchedAll: boolean;
    listLoading: boolean;
    handleFetchNextPage: () => void;
  };
}

interface SelectedFieldsToDisplay {
  displayPlate: boolean;
  displayDate: boolean;
  displayPrice: boolean;
  displayUserName: boolean;
  displayTotalHours: boolean;
}

export const PericiasListByDateComponent: React.FC<PericiasListByDateComponentProps> = ({ props }) => {
  const { pericias, selectedFieldsToDisplay, totalPrice, totalCostumers, fetchedAll, listLoading, handleFetchNextPage } = props;
  const { displayPlate, displayDate, displayPrice, displayUserName, displayTotalHours } = selectedFieldsToDisplay;

  return (
    <PaperCard title="Perícias">
      <Grid item xs={12} sm={6}>
        <Typography variant="body1" fontWeight="bold">
          Números
        </Typography>
        <Typography variant="body2" key="total-pericias">{`Perícias: ${pericias.length}`}</Typography>
        <Typography variant="body2" key="total-costumers">{`Clientes: ${totalCostumers}`}</Typography>
        <Typography variant="body2" key="total-price">{`Valor total: ${currencyMask(formatIntegerToCurrency(totalPrice))}`}</Typography>
      </Grid>
      <Grid item xs={12} mt={3}>
        <LoadingButton
          type="submit"
          fullWidth
          variant="contained"
          loading={listLoading}
          onClick={handleFetchNextPage}
          disabled={fetchedAll}
        >
          {!fetchedAll ? "Carregar mais" : "Mostrando todas as perícias"}
        </LoadingButton>
      </Grid>
      {
        <ListItem
          key="report-header"
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            textAlign: "center",
            flexWrap: "wrap"
          }}
        >
          {listHeader(selectedFieldsToDisplay)}
        </ListItem>
      }

      {pericias.map((pericia) => {
        const { car, totalHours, costumer } = pericia;
        const { plate, model, brand, chassisNumber } = car;
        const price = getPericiaCustomPrice(pericia);
        const status = getPericiaStatus(pericia);

        return (
          <ListItem key={pericia.id}>
            <ListItemButton
              // onClick={() => navigate(`/pericias/${pericia.id}`)}
              role={undefined}
              dense
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                textAlign: "center",
                flexWrap: "wrap"
              }}
            >
              <ListItemText primary={`${costumer.name}`} sx={{ flex: "1", minWidth: 0, maxWidth: "100%" }} />
              <ListItemText primary={`${status}`} sx={{ flex: "1", minWidth: 0, maxWidth: "100%" }} />
              <ListItemText primary={`${brand} ${model}`} sx={{ flex: "1", minWidth: 0, maxWidth: "100%" }} />
              {displayPlate && (
                <ListItemText primary={`${plate || "-"}  (${chassisNumber})`} sx={{ flex: "1", minWidth: 0, maxWidth: "100%" }} />
              )}
              {displayDate && (
                <ListItemText primary={pericia.createdAt.toLocaleDateString("pt-BR")} sx={{ flex: "1", minWidth: 0, maxWidth: "100%" }} />
              )}
              {displayUserName && (
                <ListItemText
                  primary={pericia.repairRecords[0] ? pericia.repairRecords[0].user.display_name : "-"}
                  sx={{ flex: "1", minWidth: 0, maxWidth: "100%" }}
                />
              )}
              {displayPrice && (
                <ListItemText
                  primary={`${currencyMask(formatIntegerToCurrency(price))}`}
                  sx={{ flex: "1", minWidth: 0, maxWidth: "100%" }}
                />
              )}
              {displayTotalHours && <ListItemText primary={`${totalHours}`} sx={{ flex: "1", minWidth: 0, maxWidth: "100%" }} />}
            </ListItemButton>
          </ListItem>
        );
      })}
      {displayPrice && (
        <Grid item xs={12} sm={12} mt={5} container justifyContent="flex-end">
          <TextField label="Total" variant="standard" disabled value={currencyMask(formatIntegerToCurrency(totalPrice))} />
        </Grid>
      )}
    </PaperCard>
  );
};

const listHeader = (fields: SelectedFieldsToDisplay) => {
  const headers = [
    { label: "CLIENTE", display: true },
    { label: "STATUS", display: true },
    { label: "MODELO", display: true }
  ];
  if (fields.displayPlate) headers.push({ label: "PLACA", display: true });
  if (fields.displayDate) headers.push({ label: "DATA", display: true });
  if (fields.displayUserName) headers.push({ label: "TÉCNICO", display: true });
  if (fields.displayPrice) headers.push({ label: "VALOR", display: true });
  if (fields.displayTotalHours) headers.push({ label: "HORAS", display: true });

  return (
    <ListItem
      divider
      key="report-header"
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        textAlign: "center",
        flexWrap: "wrap"
      }}
    >
      {headers.map((header) => {
        return <ListItemText primary={`${header.label}`} sx={{ flex: "1", minWidth: 0, maxWidth: "100%" }} />;
      })}
    </ListItem>
  );
};

const getPericiaStatus = (pericia: PericiaInvoiceItem) => {
  if (pericia.billed) return "Faturado";
  if (pericia.isPriceCalculated) return "Controlado";
  if (pericia.done) return "Finalizado";
  if (!pericia.done) return "Andamento";
};
